import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.array.map.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TeDialog from 'src/components/Dialogs/TEDialog';
import { dialog } from 'src/boot/mixins.js';
import Entry from 'src/store/models/Entry';
import PhaseCategory from 'src/store/models/PhaseCategory';
import Project from 'src/store/models/Project';
import TagList from 'src/store/models/TagList';
import Client from 'src/store/models/Client';
import Timer from 'src/store/models/Timer';
import User from 'src/store/models/User';
import Account from 'src/store/models/Account';
export default {
  mixins: [dialog],
  components: {
    TeDialog: TeDialog
  },
  props: ['type', 'entity'],
  data: function data() {
    return {
      loading: false
    };
  },
  watch: {},
  computed: {},
  methods: {
    deleteEntity: function deleteEntity() {
      var _this = this;

      User.$updateMe({
        settings: _objectSpread(_objectSpread({}, this.me.settings), {}, {
          showDeleteDemoDialog: 0
        })
      }).then(function () {
        if (_this.type === 'entry' && _this.entity) {
          var entry = Entry.find(_this.entity.entry_id);
          entry.$delete().then(function () {
            _this.$q.notify({
              message: _this.$t('general.deleted_entry'),
              type: 'positive'
            });
          }).catch(function () {});
        } else if (_this.type === 'timer' && _this.entity) {
          var timer = Timer.find(_this.entity.timer_id);
          timer.$delete().then(function () {
            _this.$q.notify({
              message: _this.$t('general.deleted_timer'),
              type: 'positive'
            });
          }).catch(function () {});
        }

        _this.hide();
      }).catch(function () {});
    },
    deleteDemoData: function deleteDemoData() {
      var _this2 = this;

      if (this.me.is_owner) {
        Account.$deleteDemoData(this.me.account_id).then(function () {
          Timer.query().where('account_id', _this2.me.account_id).where('platform', 'demodata').get().map(function (timer) {
            Timer.delete(timer.timer_id);
          });
          Entry.query().where('account_id', _this2.me.account_id).where('platform', 'demodata').get().map(function (entry) {
            Entry.delete(entry.entry_id);
          });
          Project.delete(function (project) {
            return project.account_id === _this2.me.account_id && project.is_demo === 1;
          });
          PhaseCategory.delete(function (phaseCategory) {
            return phaseCategory.account_id === _this2.me.account_id && phaseCategory.is_demo === 1;
          });
          TagList.delete(function (tagList) {
            return tagList.account_id === _this2.me.account_id && tagList.is_demo === 1;
          });
          Client.delete(function (client) {
            return client.account_id === _this2.me.account_id && client.is_demo === 1;
          }); // Timer.delete((timer) => {
          //   return timer.user_id === this.me.user_id && timer.platform === 'demodata'
          // })
          // Entry.delete((entry) => {
          //   return entry.user_id === this.me.user_id && entry.platform === 'demodata'
          // })

          _this2.$root.$emit('refresh-calendar');

          _this2.$q.notify({
            message: _this2.$t('components.deleteDemoDialog.demo_data_cleared'),
            type: 'positive'
          });

          _this2.hide();
        }).catch(function () {});
      } else {
        User.$deleteDemoData(this.me.user_id).then(function () {
          Timer.query().where('user_id', _this2.me.user_id).where('platform', 'demodata').get().map(function (timer) {
            Timer.delete(timer.timer_id);
          });
          Entry.query().where('user_id', _this2.me.user_id).where('platform', 'demodata').get().map(function (entry) {
            Entry.delete(entry.entry_id);
          });

          _this2.$root.$emit('refresh-calendar');

          _this2.$q.notify({
            message: _this2.$t('components.deleteDemoDialog.demo_data_cleared'),
            type: 'positive'
          });

          _this2.hide();
        }).catch(function () {});
      }
    }
  }
};